import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';
import { ResumeIcon } from '../content/ResumeButton';
import Swal from 'sweetalert2';
import ResumePDF from './../../assets/Jobin_resume.pdf';

const useStyles = makeStyles((theme) => ({
  resumeLink: {
    position: 'fixed',
    bottom: theme.spacing(6),
    left: theme.spacing(6),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-3px)',
      '& svg': {
        transform: 'scale(1.1)',
      },
    },
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(2),
      bottom: theme.spacing(2),
    },
  },
  swalBox: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    color: `${theme.palette.text.primary} !important`,
    borderRadius: '12px !important',
    padding: '1.5rem !important',
  },
}));

export const Resume = () => {
  const classes = useStyles();
  const theme = useTheme(); // Get the current theme

  const handleResumeClick = (e) => {
    e.preventDefault();

    Swal.fire({
      title: 'Get My Resume',
      html: `
        <div style="text-align: center;">
          <p style="margin-bottom: 1.5rem;">
            For my latest resume, please contact me via email.<br/>
            Or download the current version below:
          </p>
          <a href="${ResumePDF}" download="Jobin_Abraham_Resume.pdf" 
             style="
               background: ${theme.palette.secondary.main};
               color: white;
               padding: 0.5rem 1rem;
               border-radius: 4px;
               text-decoration: none;
               display: inline-block;
               margin-top: 1rem;
             ">
            Download Resume
          </a>
        </div>
      `,
      imageUrl: "https://img.icons8.com/color/96/resume.png",
      imageWidth: 64,
      imageHeight: 64,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.error.main,
      confirmButtonText: 'Contact via Email',
      cancelButtonText: 'Cancel',
      customClass: {
        popup: classes.swalBox,
      },
      backdrop: `
        rgba(84, 84, 84, 0.8)
        linear-gradient(
          45deg,
          ${theme.palette.primary.main}20,
          ${theme.palette.secondary.main}20
        )
      `,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = `mailto:hello@jobinabraham.me?subject=Request for Resume&body=Hi Jobin,%0A%0ACould you please share your latest resume?%0A%0AJob Details:%0A%0A[Please include relevant details here]%0A%0ALooking forward to your response.%0A%0ABest regards,%0A[Your Name]`;
      }
    });
  };

  return (
    <Link
      color="inherit"
      underline="none"
      href="#"
      onClick={handleResumeClick}
      className={classes.resumeLink}
      aria-label="Download Resume"
    >
      <ResumeIcon />
    </Link>
  );
};
